import React from "react";

const SvgMegaphoneFilled = props => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path
      id="megaphoneFilled_svg__a"
      d="M2 9.182c.037-.163.057-.333.115-.489.302-.816.89-1.288 1.75-1.417a1.86 1.86 0 0 1 .284-.015h4.165v13.681H6.215a1.738 1.738 0 0 1-.004-.102v-5.158h-.104c-.648 0-1.295 0-1.942-.002-.123 0-.247-.01-.369-.026a2.104 2.104 0 0 1-1.75-1.64c-.017-.084-.03-.17-.046-.254V9.182zM18.827 2h2.115l-.001 7.574c0 .057.018.087.065.118.483.308.796.74.93 1.297.029.122.043.248.064.372v.22c-.006.023-.012.046-.015.069-.07.684-.395 1.213-.969 1.59-.053.035-.076.069-.075.136.002 2.522 0 5.044 0 7.566h-2.114c-.009-.024-.014-.05-.026-.072a401.65 401.65 0 0 0-.986-1.969.208.208 0 0 0-.097-.09c-.974-.42-1.947-.836-2.92-1.254-1.43-.612-2.858-1.225-4.287-1.835-.072-.03-.095-.065-.095-.143.002-2.736.002-5.472 0-8.207 0-.083.023-.122.102-.155 1.206-.513 2.41-1.03 3.615-1.547 1.195-.512 2.39-1.024 3.585-1.538a.211.211 0 0 0 .097-.09c.331-.656.659-1.313.986-1.97.012-.023.017-.048.026-.072z"
    />
  </svg>
);

export default SvgMegaphoneFilled;
